


























import Vue from "vue";

export default Vue.extend({
  name: "RecruiterWrapper",
  components: {},
  data() {
    return {
      sidebarLinks: [
        {
          name: "Demand Data",
          link: "/skills/demand",
          children: []
        },
        {
          name: "Supply Data",
          link: "/skills/supply",
          children: []
        }
        // {
        //   name: "Demand (New)",
        //   link: "/skills/new-demand",
        //   children: []
        // }
        // {
        //   name: "Supply vs Demand",
        //   link: "/skills/supply-demand",
        //   children: []
        // }
      ],
      selectedItem: {} as any
    };
  },
  computed: {
    getData(): any {
      // return this.sidebarLinks.filter((item) => item.link !== this.$route.path);
      return this.sidebarLinks;
    }
  },
  methods: {
    on_btn_click(item: any) {
      this.selectedItem = item;
      this.$router.push(item.link);
    }
  }
});
